import React, { useState, useEffect } from "react";
import axios from "axios";
import { FiExternalLink, FiPlusCircle } from "react-icons/fi";
import { Link } from "react-router-dom";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get("https://3esolarventures.com/backend/get_blogs.php");
        if (Array.isArray(response.data)) {
          setBlogs(response.data);
        } else {
          setBlogs([]);
          console.error("Unexpected API response:", response.data);
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
        setBlogs([]);
      }
      setLoading(false);
    };

    fetchBlogs();
  }, []);

  return (
    <div className="p-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-2xl font-bold text-gray-800 mb-2">Blogs</h1>
            <p className="text-gray-600">Your collection of insightful blog posts</p>
          </div>
          <Link
            to="/admin/blogs/add"
            className="bg-teal-600 text-white px-4 py-2 rounded-lg flex items-center space-x-2 hover:bg-teal-700 transition-colors"
            aria-label="Add New Blog"
          >
            <FiPlusCircle className="w-5 h-5" />
            <span>Add Blog</span>
          </Link>
        </div>

        {/* Blog List */}
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-8 w-8 border-4 border-teal-500 border-t-transparent"></div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array.isArray(blogs) && blogs.length > 0 ? (
              blogs.map((blog) => (
                <article key={blog.id} className="bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-300">
                  <div className="relative">
                    <img src={blog.featured_image} alt={blog.title} className="w-full h-48 object-cover" />
                  </div>
                  <div className="p-6">
                    <h2 className="text-xl font-semibold text-gray-800">{blog.title}</h2>
                    <p className="text-gray-600">{blog.content.substring(0, 200)}...</p>
                  </div>
                </article>
              ))
            ) : (
              <p className="text-gray-500">No blogs available</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Blogs;
